import React, { useEffect, useRef } from 'react';
import PageHeader from '../common/PageHeader';
import { logger } from '../../utils/logger';
import '../../styles/Terms.css';

const Terms: React.FC = () => {
  const contentSectionRef = useRef<HTMLElement | null>(null);

  // Function to check if elements are in viewport to apply fade effect
  const checkFade = () => {
    if (contentSectionRef.current) {
      const elementTop = contentSectionRef.current.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      if (elementTop < windowHeight - 100) {
        contentSectionRef.current.classList.add('active');
      }
    }
  };

  // Set up fade effect on scroll
  useEffect(() => {
    // Initial check
    checkFade();
    
    // Log page visit
    logger.info('📜 Terms page visited', { component: 'Terms' });

    // Add scroll event listener
    window.addEventListener('scroll', checkFade);

    // Clean up
    return () => {
      window.removeEventListener('scroll', checkFade);
    };
  }, []);

  return (
    <>      <PageHeader
        title="Terms of Service"
        subtitle="Our service agreements and policies"
      />

      <section className="container fade-in" ref={contentSectionRef}>
        <div className="ter-container">
          <h1 className="ter-title">Terms of Service</h1>
          <div className="ter-content">
          <section className="ter-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using the services provided by BodySharing ("we", "our", "us"), you agree to be bound 
              by these Terms of Service, all applicable laws and regulations, and agree that you are responsible 
              for compliance with any applicable local laws.
            </p>
            <p>
              If you do not agree with any of these terms, you are prohibited from using or accessing this site. 
              The materials contained in this website are protected by applicable copyright and trademark law.
            </p>
          </section>
          
          <section className="ter-section">
            <h2>2. Use License</h2>
            <p>
              Permission is granted to temporarily download one copy of the materials (information or software) 
              on BodySharing's website for personal, non-commercial transitory viewing only. This is the grant of 
              a license, not a transfer of title, and under this license you may not:
            </p>
            <ul className="ter-list">
              <li>modify or copy the materials;</li>
              <li>use the materials for any commercial purpose, or for any public display (commercial or non-commercial);</li>
              <li>attempt to decompile or reverse engineer any software contained on BodySharing's website;</li>
              <li>remove any copyright or other proprietary notations from the materials; or</li>
              <li>transfer the materials to another person or "mirror" the materials on any other server.</li>
            </ul>
          </section>
          
          <section className="ter-section">
            <h2>3. Disclaimer</h2>
            <p>
              The materials on BodySharing's website are provided on an 'as is' basis. BodySharing makes no warranties, 
              expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, 
              implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement 
              of intellectual property or other violation of rights.
            </p>
          </section>
          
          <section className="ter-section">
            <h2>4. Limitations</h2>
            <p>
              In no event shall BodySharing or its suppliers be liable for any damages (including, without limitation, 
              damages for loss of data or profit, or due to business interruption) arising out of the use or inability 
              to use the materials on BodySharing's website, even if BodySharing or a BodySharing authorized representative 
              has been notified orally or in writing of the possibility of such damage.
            </p>            
          </section>
          </div>
        </div>
      </section>
    </>
  );
};

export default Terms;
